import { useEffect } from "react";
import { UseFormReturn, Path, SetFieldValue, FieldValues } from "react-hook-form";

export interface SigningSuccessData {
   userId: Guid | null,
   fullName: string | null,   
   joinFlow?: boolean,
   redirectUrl?: string
}

export interface SigningEmailProps {
   email?: string,
   onEmailChange?: (string) => void;
}

export const useSigningEmailEffect = <T extends FieldValues>(signingEmailProps: SigningEmailProps, formMethods: UseFormReturn<T>, formEmailFieldName: Path<T>) => {

   const emailValue = formMethods.watch(formEmailFieldName);   

   useEffect(() => {      
      if (signingEmailProps.onEmailChange) {
         signingEmailProps.onEmailChange(emailValue);
      }
   }, [emailValue])

   useEffect(() => {
      formMethods.setValue(formEmailFieldName, signingEmailProps.email as SetFieldValue<T>, { shouldValidate: signingEmailProps.email ? true : undefined });
   }, [signingEmailProps.email])
}